// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2yEO5","log":"ModalInventoryLogs_log__frMa5","date":"ModalInventoryLogs_date__2_Ym8","userName":"ModalInventoryLogs_userName__uzobs"};